import { useState } from 'react';
import { useUserContextPreferences } from '../../../../../hooks/useUserContextPreferences';
import { useUpdateOrCreateUiPreference } from '../../../../../services/modules/userContextPreferences/userContextPreferences.mutations';
import { UiPreferenceRecognizedKeys } from '../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';
import { useNetworkContext } from '../../../../offline/contexts/network/network.context';
import { AddOrderProductToggleState } from '../orderObjectPage.types';
import {
  DEFAULT_ADD_ORDER_PRODUCT_TOGGLE_STATE,
  parseAddOrderProductToggleState,
} from './useAddProductToggle.utils';

const useAddProductTogglePreference = () => {
  const { team } = useApplicationContext();
  const teamId = team?.id;

  const { isOnline } = useNetworkContext();
  const { getUiPreferenceValue, hasFetchedUserPreferences } = useUserContextPreferences();
  const { mutate: updateUiPreference } = useUpdateOrCreateUiPreference();

  const [selectedPreference, setSelectedPreference] = useState<AddOrderProductToggleState | null>(
    null,
  );
  const [preferenceOwnerTeamId, setPreferenceOwnerTeamId] = useState(teamId);

  if (preferenceOwnerTeamId !== teamId) {
    setPreferenceOwnerTeamId(teamId);
    setSelectedPreference(null);
  }

  const remotePreference = parseAddOrderProductToggleState(
    getUiPreferenceValue(UiPreferenceRecognizedKeys.ADD_ORDER_PRODUCT_TOGGLE),
  );

  const preference =
    selectedPreference ?? remotePreference ?? DEFAULT_ADD_ORDER_PRODUCT_TOGGLE_STATE;

  const isPreferenceReady = !!selectedPreference || !isOnline || hasFetchedUserPreferences;

  const savePreference = (nextPreference: AddOrderProductToggleState) => {
    setSelectedPreference(nextPreference);

    if (!teamId || !isOnline) {
      return;
    }

    updateUiPreference({
      key: UiPreferenceRecognizedKeys.ADD_ORDER_PRODUCT_TOGGLE,
      value: nextPreference,
    });
  };

  return { preference, isPreferenceReady, savePreference };
};

export default useAddProductTogglePreference;
